import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Colorable extends Vue {
  @Prop({ type: Boolean, default: false }) primary!: boolean
  @Prop({ type: Boolean, default: false }) secondary!: boolean
  @Prop({ type: Boolean, default: false  }) light!: boolean
  @Prop({ type: Boolean, default: false  }) dark!: boolean
}
